import React, {useState} from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import {StyledMuiButton} from './styledTabs';
const AutoPlaySwipeableViews = SwipeableViews
// autoPlay(SwipeableViews);

const useStyles = makeStyles(theme => ({
  root: {
    // maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: 'auto',
    maxHeight: '55vh',
    display: 'block',
    // maxWidth: 400,
    overflow: 'hidden',
    width: '100%',
    objectFit: 'contain'
  },
  carouselWrapper: {
    // display: 'flex',
    '&> div': {
      // display: 'flex'
      height: '100%'
    },
    '& img': {
      display: 'flex',
      objectFit: 'contain',
      height: '100%'
    }
  }
}));

function SwipeableTextMobileStepper({title = "", images: propImages = []}) {
  let [images, setImages] = useState(propImages);
  let [renderCounter, setRenderCounter] = useState(1);
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const maxSteps = images.length;

  // useEffect(() => {
  //   setTimeout(() => {
  //     setImages([
  //       "https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60",
  //       "https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=800&h=250&q=60",
  //       "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250&q=80",
  //       "https://images.unsplash.com/photo-1518732714860-b62714ce0c59?auto=format&fit=crop&w=400&h=250&q=60",
  //       "https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60"
  //     ])
  //
  //   }, 100)
  // }, [])

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStepChange = step => {
    setActiveStep(step);
  };

  const handleImageLoadError = () => {
    // devConsolelog('carousel images image error ', images);
    // setTimeout(() => {
    //   if(images.length > 0) {
    //     setImages(images.map(item => `${TRAVCLAN_LOGO}`));
    //     setRenderCounter(++renderCounter)
    //   }
    // }, 100)
   }

  // devConsolelog('carousel images ', images, renderCounter)

  //set fallback images for bad image error
  // useEffect(() => {
  //   if(!images || images.length <= 0) setImages([`${TRAVCLAN_LOGO}`])
  // }, [])

  // return (<Typography variant="h6" color="textSecondary">No images found!</Typography>)
  return (
    <div className={classes.root}>
      <Paper square elevation={0} className={classes.header}>
        <Typography variant="h4">{title}</Typography>
      </Paper>
      <AutoPlaySwipeableViews
        key={renderCounter}
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        resistance={true}
        slideClassName={classes.carouselWrapper}
      >
        {images.map((step, index) => (
          <div key={index}>
            {Math.abs(activeStep - index) <= 2 ? (
              <img className={classes.img} src={step} alt={title} onError={handleImageLoadError}/>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="dots"
        activeStep={activeStep}
        nextButton={
          <StyledMuiButton variant="outlined" size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </StyledMuiButton>
        }
        backButton={
          <StyledMuiButton variant="outlined" size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </StyledMuiButton>
        }
      />
    </div>
  );
}

export default SwipeableTextMobileStepper;
